export default [
  {
    // 账号中心
    path: '/user-center/account',
    component: resolve => require(['./Index'], resolve),
    redirect: '/user-center/account/base-info',
    children: [
      {
        // 账号中心/基本信息
        path: 'base-info',
        component: resolve => require(['./view/base-info/Index'], resolve),
      },
      {
        // 账号中心/基本信息--修改手机号
        path: 'modify-info',
        component: resolve => require(['./view/base-info/ModifyInfo'], resolve),
        meta: {
          parent: "/user-center/account/base-info",
        }
      },
      {
        // 账号中心/实名认证
        path: 'certification',
        component: resolve => require(['./view/certification/Index'], resolve),
      },

      // 企业认证
      {
        // 账号中心/实名认证/选择企业认证方式
        path: 'business-authway',
        component: resolve => require(['./view/certification/BusinessAuthway'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },
      {
        // 账号中心/实名认证/企业对公账户认证
        path: 'business-account',
        component: resolve => require(['./view/certification/BusinessAccount'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },
      {
        // 账号中心/实名认证/企业证件认证
        path: 'business-credent',
        component: resolve => require(['./view/certification/BusinessCredent'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },
      {
        // 账号中心/实名认证/选择企业认证  变更类型
        path: 'business-authchange',
        component: resolve => require(['./view/certification/BusinessAuthChange'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },
      {
        // 账号中心/实名认证/企业 主体变更
        path: 'business-mainchange',
        component: resolve => require(['./view/certification/BusinessMainChange'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },
      {
        // 账号中心/实名认证/企业 名称变更
        path: 'business-namechange',
        component: resolve => require(['./view/certification/BusinessNameChange'],resolve),
        meta: {
          parent: "/user-center/account/certification"
        }
      },

      
      // 查看认证信息
      {
        // 账号中心/实名认证
        path: 'viewCertifyInfo',
        component: resolve => require(['./view/certification/ViewCertification'], resolve),
        meta: {
          parent: "/user-center/account/certification"
        },
      },
      {
        // 账号中心/收件地址
        path: 'address',
        component: resolve => require(['./view/address/Index'], resolve)
      },
      {
        // 商业信息认证
        path: 'authentication',
        component: resolve => require(['./view/businessInfo/authenticationStatePage'], resolve)
      },
      // {
      //   //绑定多云账号
      //   path: 'bindingBp',
      //   component: resolve => require(['./view/bindingBp'], resolve),
      // }
      {
        // 账号中心/商业信息
        path: 'addBusinessInfo',
        component: resolve => require(['./view/businessInfo/addBusinessInfo'], resolve),
        meta: {
          parent: "/user-center/account/authentication"
        },
      },
      {
        // 账号中心/商业信息
        path: 'authenticationDetial',
        component: resolve => require(['./view/businessInfo/authenticationStateDetailPage'], resolve),
        meta: {
          parent: "/user-center/account/authentication"
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user-center/account/router.js